import React from 'react'
import { t } from 'ttag'

import TextQuestion from './questiontypes/TextQuestion'
import MultiChoiceQuestion from './questiontypes/MultiChoiceQuestion'
import RatingQuestion from './questiontypes/RatingQuestion'
import FileQuestion from './questiontypes/FileQuestion'

import { replaceVariables } from '../../actions/planning/assignments'

class OutputSurvey extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      isSubmitting: false,
      errorMesage: null
    }
  }

  componentDidUpdate(prevProps) {
    // Check if response errors have changed and we're currently submitting
    if (
      this.state.isSubmitting &&
      prevProps.response.errors !== this.props.response.errors
    ) {
      const hasErrors = Object.keys(this.props.response.errors || {}).length > 0

      // If new errors appeared, reset the submitting state to allow user to fix and retry
      if (hasErrors) {
        console.log('Props errors changed, resetting isSubmitting state')
        this.setState({
          ...this.state,
          isSubmitting: false
        })
      }
    }
  }

  cancelButton = () => {
    if (this.props.onSurveyCancel) {
      return (
        <input
          style={{ marginLeft: '5px' }}
          type="button"
          className="btn btn-danger"
          onClick={this.props.onSurveyCancel}
          value="Cancel"
          disabled={this.state.isSubmitting}
        />
      )
    }

    return null
  }

  chooseQuestion = props => {
    switch (props.question.questionTypeId) {
      case 1:
        return <TextQuestion {...props} />
      case 2:
        return <MultiChoiceQuestion {...props} />
      case 3:
        return <RatingQuestion {...props} />
      case 4:
      case 5:
      case 6:
      case 8:
        return <MultiChoiceQuestion {...props} />
      case 7:
        return <FileQuestion {...props} />
      default:
        return null
    }
  }

  validate = quests => {
    console.log('Quests', quests)
    console.log('Response', this.props.response)
    const errors = quests.reduce((errors, q) => {
      const error = this.props.validateResponse(q, this.props.response.items[q.id])

      console.log('Error2', this.props.response.errors[q.id])
      console.log('Error', error)

      if (error) {
        return { ...errors, [q.id]: error }
      }

      return errors
    }, {})

    return errors
  }

  render() {
    const { survey, response, onRespond, onSubmitSurvey, showTitle, validateResponse } =
      this.props

    if (survey === null) {
      return null
    }

    if (this.state.submitted) {
      console.log('Found submission')

      return (
        <div className="alert alert-info">
          <h3>
            {survey.confirmationText || t`Thank you, your responses have been submitted`}
          </h3>
        </div>
      )
    }

    if (!survey.canSubmit && !this.props.allowModifications) {
      return (
        <div className="alert alert-danger">{t`You are not eligible to take this survey at this time because you have already completed it and multiple submissions are not allowed.`}</div>
      )
    }

    const quests = survey.questions.filter(a => a && a.hasOwnProperty('id'))

    return (
      <form
        className="survey"
        onSubmit={e => {
          e.preventDefault()

          // Disable button immediately to prevent double clicks
          this.setState({
            ...this.state,
            isSubmitting: true,
            errorMesage: null
          })

          const errors = this.validate(quests)
          const valid = Object.keys(errors).length === 0

          console.log('Valid', valid, errors)

          if (valid) {
            onSubmitSurvey(e.target)
              .then(c => {
                console.log(c, this.state)
                this.setState({
                  ...this.state,
                  errorMesage: null,
                  submitted: true,
                  isSubmitting: false
                })
                console.log(c, this.state)
              })
              .catch(e => {
                this.setState({
                  ...this.state,
                  errorMesage: e.restCall?.result?.error,
                  isSubmitting: false
                })
              })
          } else {
            // Validation failed, re-enable the button
            this.setState({
              ...this.state,
              isSubmitting: false
            })
          }
        }}>
        {this.state.errorMesage && (
          <div className="alert alert-danger">{t`Could not submit survey because: ${this.state.errorMesage}`}</div>
        )}
        {showTitle ? <h3>{survey.name}</h3> : null}
        <div>{replaceVariables(survey.description)}</div>
        <div className="question-list" key={`survey-question-list.${survey.id}`}>
          {quests
            .sort((a, b) => {
              const ob = ((a && a.orderBy) || 0) - ((b && b.orderBy) || 0)

              if (ob === 0) {
                if ((a && a.label) < (b && b.label)) {
                  return -1
                }

                if ((a && a.label) > (b && b.label)) {
                  return 1
                }
              }

              return ob
            })
            .map(s => {
              const error = response.errors[s.id]
              const errorClass = (error && 'has-error') || ''

              return (
                <div className={`survey-question form-group ${errorClass}`} key={s.id}>
                  {[
                    this.chooseQuestion({
                      response: response.items[s.id],
                      error,
                      key: `question-${s.id}`,
                      question: s,
                      onRespond,
                      validateResponse
                    }),
                    (error && (
                      <div className="help-block" key={`help-${s.id}`}>
                        {error}
                      </div>
                    )) ||
                      null
                  ]}
                </div>
              )
            })}
        </div>

        <div className="nav">
          <input
            type="submit"
            className="btn btn-success"
            value={this.state.isSubmitting ? t`Submitting...` : survey.buttonText}
            disabled={this.state.isSubmitting}
          />
          {this.cancelButton()}
        </div>
      </form>
    )
  }
}

export default OutputSurvey
